import React from "react";
import GitHubCalendar from "react-github-calendar";
import ProjectCard from "./ProjectCard";
import "../Style/projects.css";
import html from "../Components/Images/Html.png";
import css from "../Components/Images/Css.png";
import react from "../Components/Images/react.png";
import js from "../Components/Images/js.png";
import chakra from "../Components/Images/chakra.png";
import express from "../Components/Images/express.png"
import node from "../Components/Images/nodejs.png";
import mongo from "../Components/Images/mongodb-seeklogo.com.svg";

const Projects = () => {
  let Little_Lion = [
    {
      imgarr: [
        {
          img: "https://i.imgur.com/YEXnXgM.png",
        },
        {
          img: "https://i.imgur.com/8rmrXL7.png",
        },
        {
          img: "https://i.imgur.com/cgPiNXF.png",
        },
        {
          img: "https://i.imgur.com/3pQViYy.png",
        },
        {
          img: "https://i.imgur.com/Zj5S87q.png",
        },
        {
          img: "https://i.imgur.com/lWaKMIO.png",
        },
        {
          img: "https://i.imgur.com/irRkhgh.png",
        },
        {
          img: "https://i.imgur.com/8E7Fpnr.png",
        },
      ],
      des: `Little Lion is a social
        media management platform for small to
        midsize businesses that helps users publish
        content, engage clients and analyze their
          social media performance.`,
      title: "Little Lion",
      techstack: [
        { src: html, name: "HTML" },
        { src: css, name: "CSS" },
        { src: js, name: "JavaScript" },
        { src: react, name: "React" },
        { src: node, name: "node" },
        { src: chakra, name: "Chakra" },
      ],
      live: `https://little-lion.netlify.app/`,
      github: `https://github.com/gouravluv2code/lean-school-408`,
      dplink: "",
    },
  ];
  let Smart_Shop = [
    {
      imgarr: [
        {
          img: "https://github.com/mak-1997/parsimonious-mouth-5256-/raw/main/public/homepage.png",
        },
        {
          img: "https://github.com/mak-1997/parsimonious-mouth-5256-/raw/main/public/register.png",
        },
        {
          img: "https://github.com/mak-1997/parsimonious-mouth-5256-/raw/main/public/products.png",
        },
        {
          img: "https://github.com/mak-1997/parsimonious-mouth-5256-/raw/main/public/singleProduct.png",
        },
      ],
      des: `
      Smart Shop is the perfect online marketplace to buy and sell locally! No need to visit the local market to find the best deals on pre-owned items! Here you’ll find a wide selection of like new products.`,
      title: "Smart Shop",
      techstack: [
        { src: html, name: "HTML" },
        { src: css, name: "CSS" },
        { src: js, name: "JavaScript" },
        { src: react, name: "React" },
        { src: node, name: "node" },
        { src: chakra, name: "Chakra" },
      ],
      live: `https://smart-shop-alpha.vercel.app/`,
      github: `https://github.com/mak-1997/Smart-Shop`,
      dplink: "",
    },
  ];

  let AXOX = [
    {
      imgarr: [
        {
          img: "https://i.postimg.cc/26YQktfC/home.png",
        },
        {
          img: "https://i.postimg.cc/N0m8wcSN/prod1.png",
        },
        {
          img: "https://i.postimg.cc/fTqfc5Yv/cart.png",
        },
        {
          img: "https://i.postimg.cc/RZj18Fs6/prod2.png",
        },
        {
          img: "https://i.postimg.cc/13gcJ6H1/signup.png",
        }

      ],
      des: `
      AXOX is a British online fashion and cosmetic retailer. The company was founded in 2000 in London, primarily aimed at young adults.`,
      title: "AXOX",
      techstack: [
        { src: html, name: "HTML" },
        { src: css, name: "CSS" },
        { src: js, name: "JavaScript" },
        { src: react, name: "React" },
        { src: node, name: "node" },
        { src: chakra, name: "Chakra" },
      ],
      live: `https://civil-kettle-7397-three.vercel.app/`,
      github: `https://github.com/Kunjan0/civil-kettle-7397`,
      dplink: "",
    },
  ];

  let health_cube = [
    {
      imgarr: [
        {
          img: "https://github.com/Shanky43/subdued-stocking-2928/raw/main/frontend/src/Assests/HomePage%20Image.png?raw=true",
        },
        {
          img: "https://github.com/Shanky43/subdued-stocking-2928/raw/main/frontend/src/Assests/allproductpage1.png?raw=true",
        },
        {
          img: "https://github.com/Shanky43/subdued-stocking-2928/raw/main/frontend/src/Assests/SignUpPage.png?raw=true",
        },
        {
          img: "https://github.com/Shanky43/subdued-stocking-2928/raw/main/frontend/src/Assests/SignInPage.png?raw=true",
        },
        {
          img: "https://user-images.githubusercontent.com/91946820/174493141-4bd45232-ecf2-4e7f-b91a-703b67bff5a9.png",
        },
        {
          img: "https://github.com/Shanky43/subdued-stocking-2928/raw/main/frontend/src/Assests/ProductsPage.png?raw=true",
        },
        {
          img: "https://github.com/Shanky43/subdued-stocking-2928/raw/main/frontend/src/Assests/cartpage.png?raw=true",
        },
        {
          img: "https://github.com/Shanky43/subdued-stocking-2928/raw/main/frontend/src/Assests/checkout%20page.png?raw=true",
        },
        {
          img: "https://github.com/Shanky43/subdued-stocking-2928/raw/main/frontend/src/Assests/OrderPage.png?raw=true",
        },
        {
          img: "https://user-images.githubusercontent.com/91946820/174493499-5077e966-2309-4c4c-84fa-5e3e88d0497b.png",
        }

      ],
      des: `
      Health Cube is a healthcare platform, it provides a range of services, including online doctor consultation, lab tests, health packages, and health content.`,
      title: "Health Cube",
      techstack: [
        { src: html, name: "HTML" },
        { src: css, name: "CSS" },
        { src: js, name: "JavaScript" },
        { src: react, name: "React" },
        { src: mongo, name: "mongodb" },
        { src: express, name: "express" },
        { src: node, name: "node" },
        { src: chakra, name: "Chakra" },
      ],
      live: `https://healthcube-bisht1418.vercel.app/`,
      github: `https://github.com/Shanky43/subdued-stocking-2928`,
      dplink: "",
    },
  ];

  let jewelLane = [
    {
      imgarr: [
        {
          img: "https://github.com/Satyamjha24/pointless-belief-3937/assets/98752820/3541575a-c85f-4ee8-abf6-563e109f25c3",
        },
        {
          img: "https://github.com/Satyamjha24/pointless-belief-3937/assets/98752820/92fe6f00-d2e5-4147-95b1-90aef5a13858",
        },
        {
          img: "https://github.com/Satyamjha24/pointless-belief-3937/assets/98752820/09d3fd2b-9798-4014-874b-57179af8f47c",
        },
        {
          img: "https://github.com/Satyamjha24/pointless-belief-3937/assets/98752820/89c4a46a-7e70-441f-88b4-a124dea330b9",
        },
        {
          img: "https://github.com/Satyamjha24/pointless-belief-3937/assets/98752820/372870c4-2098-4932-8b58-009d9e89df2c",
        },
        {
          img: "https://github.com/Satyamjha24/pointless-belief-3937/assets/98752820/cb0cebba-d94a-44e2-915f-d9e8eb4b4b60",
        },
        {
          img: "https://github.com/Satyamjha24/pointless-belief-3937/assets/98752820/8dd8865f-858c-4a77-9282-4d8442eb6396",
        },
        {
          img: "https://github.com/Satyamjha24/pointless-belief-3937/assets/98752820/ae1c8d6a-551a-4018-9478-6c652452928a",
        }

      ],
      des: `
      Jewel Lane is a clone of an e-commerce website Caratlane which sells the best gold & diamond jewellery. They offer a wide range of rings, earrings, bangles, bracelets and necklaces at the best price.`,
      title: "Jewel Lane",
      techstack: [
        { src: html, name: "HTML" },
        { src: css, name: "CSS" },
        { src: js, name: "JavaScript" },
        { src: react, name: "React" },
        { src: mongo, name: "mongodb" },
        { src: express, name: "express" },
        { src: node, name: "node" },
        { src: chakra, name: "Chakra" },
      ],
      live: `https://jewellane.vercel.app/`,
      github: `https://github.com/Kunjan0/JewelLane`,
      dplink: "",
    },
  ];

  let ajio = [
    {
      imgarr: [
        {
          img: "https://github.com/Gangaram1998/Ajio_clone/assets/108624797/689cac67-58a6-4e79-8215-731fc3915e8e",
        },
        {
          img: "https://github.com/Gangaram1998/Ajio_clone/assets/108624797/1a8221f4-6f73-48c4-9a7e-74a1ec03932b",
        },
        {
          img: "https://github.com/Gangaram1998/Ajio_clone/assets/108624797/9493d8d7-adb0-4082-9d32-2e7d64acb7d5",
        },
        {
          img: "https://github.com/Gangaram1998/Ajio_clone/assets/108624797/6a1aabc4-538f-4d8f-ae80-1318b71a9bbf",
        },
        {
          img: "https://github.com/Gangaram1998/Ajio_clone/assets/108624797/cc0f1444-a2d1-44d7-adcd-8afa32ce508d",
        },
        {
          img: "https://github.com/Gangaram1998/Ajio_clone/assets/108624797/b9f917c4-97a6-48a8-8cf7-d530e5530d60",
        },
        {
          img: "https://github.com/Gangaram1998/Ajio_clone/assets/108624797/5237782c-da5e-41cd-8f94-d177fda9d469",
        }

      ],
      des: `
      AJIO, a fashion and lifestyle brand, is Reliance Retail's digital commerce initiative and is the ultimate fashion destination for styles that are handpicked, on trend and at prices that are the best you'll find anywhere.`,
      title: "Ajio",
      techstack: [
        { src: html, name: "HTML" },
        { src: css, name: "CSS" },
        { src: js, name: "JavaScript" },
        { src: react, name: "React" },
        { src: mongo, name: "mongodb" },
        { src: express, name: "express" },
        { src: node, name: "node" },
        { src: chakra, name: "Chakra" },
      ],
      live: `https://frontend-eight-khaki-47.vercel.app/`,
      github: `https://github.com/Kunjan0/Ajio`,
      dplink: "",
    },
  ];

  return (
    <section id="projects">
      <div
        id="tech"
        data-aos="fade-down-right"
        data-aos-duration="2000"
        data-aos-delay="300"
        margin={"auto"}
        justifycontent={"space-around"}
      >
        <h1 style={{ color: "var(--color-font)" }}>Projects </h1>
      </div>
      <div id="procard">

        <div
          data-aos="zoom-in-down"
          data-aos-duration="2000"
          data-aos-anchor-placement="top-center"
        >
          <ProjectCard arr={AXOX} />
        </div>

        <div
          data-aos="zoom-in-down"
          data-aos-duration="2000"
          data-aos-anchor-placement="top-center"
        >
          <ProjectCard arr={ajio} />
        </div>

        <div
          data-aos="zoom-in-down"
          data-aos-duration="2000"
          data-aos-anchor-placement="top-center"
        >
          <ProjectCard arr={jewelLane} />
        </div>

        <div
          data-aos="zoom-in-down"
          data-aos-duration="2000"
          data-aos-anchor-placement="top-center"
        >
          <ProjectCard arr={health_cube} />
        </div>

        <div
          data-aos="zoom-in-down"
          data-aos-duration="2000"
          data-aos-anchor-placement="top-center"
        >
          <ProjectCard arr={Little_Lion} />
        </div>


        <div
          data-aos="zoom-in-down"
          data-aos-duration="2000"
          data-aos-anchor-placement="top-center"
        >
          <ProjectCard arr={Smart_Shop} />
        </div>

      </div>


      <div
        id="gitname"
        data-aos="fade-down-right"
        data-aos-duration="2000"
        data-aos-delay="300"
        margin={"auto"}
        justifycontent={"space-around"}
      >
        <h2 style={{ color: "var(--color-font)" }}>
          Github Contribution Calender{" "}
        </h2>
      </div>
      <div
        id="calendar"
        data-aos="flip-right"
        data-aos-easing="ease-out-cubic"
        data-aos-duration="2000"
        data-aos-offset="100"

      >
        <GitHubCalendar
          className="react-activity-calendar"
          fontSize={14}
          color="#008001"
          blockRadius={1}
          blockMargin={6}
          blockSize={16}
          showWeekdayLabels
          username="Kunjan0"
        />
      </div>
      <div
        id="gitname"
        data-aos="fade-down-right"
        data-aos-duration="2000"
        data-aos-delay="300"
        margin={"auto"}
        justifycontent={"space-around"}
      >
        <h2 style={{ color: "var(--color-font)" }}>Github Stats</h2>
      </div>

      <div>
        <img style={{ height: "195px", marginLeft: "5%" }}
          id="github-top-langs"
          data-aos="flip-left"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="2000"
          data-aos-offset="100"
          alt="most used languages"
          src="https://github-readme-stats.vercel.app/api/top-langs/?username=Kunjan0&layout=compact"
        />

        <img style={{ marginLeft: "5%" }}
          id="github-streak-stats"
          data-aos="flip-left"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="2000"
          data-aos-offset="100"
          alt="status github, commits, etc..."
          src="https://github-readme-streak-stats.herokuapp.com?user=Kunjan0"
        />

        <img style={{ marginLeft: "5%" }}
          id="github-stats-card"
          data-aos="flip-left"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="2000"
          data-aos-offset="100"
          alt="Kunjan's Github Stats"
          src="https://github-readme-stats.vercel.app/api?username=Kunjan0"
        />
      </div>

    </section>
  );
};

export default Projects;
